import { render, staticRenderFns } from "./new-mass-actions-panel.vue?vue&type=template&id=c146cb50&"
import script from "./new-mass-actions-panel.vue?vue&type=script&lang=js&"
export * from "./new-mass-actions-panel.vue?vue&type=script&lang=js&"
import style0 from "./new-mass-actions-panel.vue?vue&type=style&index=0&id=c146cb50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports